define(function (require, exports, module) {
    var timeModel = require('../model/timeModel/timeModel');
    var indexV2Model = require('../model/indexV2Model/indexV2Model');
    var priceV2 = require('../unit/price/priceV2');
    var ticker = require('../unit/ticker/ticker');
    var lazyload = require('../unit/lazyload/lazyload');
    var CheckLogin = require("../model/isLogin/isLogin");
    var tplModel = require("../model/tplModel/tplModel");

    var indexV2Module = {
        init: function () {
            var self = this;
            self.loadGuessYouLike();
            self.addEvent();
            self.bindMouseHoverEvt();
            self.addSaleFloorEvent();

            // self.initHerizonalScroll();
        },
        initHerizonalScroll: function () {
            var options = {
                slidee: $('.slidee'),
                horizontal: true,
                itemNav: 'basic',
                speed: 300,
                mouseDragging: 1,
                touchDragging: 1,
                scrollBar: $('#scrollbar'),
                dragHandle: true,
                minHandleSize: 300,
                backward: $('#prev'),
                forward: $('#next'),
                moveBy: 3500
            };
            var frame = new Sly('#frame', options).init();
        },
        bindMouseHoverEvt: function () {
            $('.guarantee .more_info').on('mouseenter', function () {
                $(this).children().addClass('curr');
            }).on('mouseleave', function () {
                $(this).children().removeClass('curr');
            });
        },
        addEvent: function () {
            //左右氛围图
            if ($("#lTone").attr("imgUrl")) {
                var url = $("#lTone").attr("imgUrl");
                var src = $("#lTone").attr("textUrl") || "#";
                var clstag = $("#lTone").attr("clstag") || "";
                $(".slide").append('<div class="l-tone">' +
                    '<a href="' + src + '" clstag="' + clstag + '" target="_blank">' +
                    '<img src="' + url + '">' +
                    '</a>' +
                    '</div>');
            }

            if ($("#rTone").attr("imgUrl")) {
                var url = $("#rTone").attr("imgUrl");
                var src = $("#rTone").attr("textUrl") || "#";
                var clstag = $("#rTone").attr("clstag") || "";
                $(".slide").append('<div class="r-tone">' +
                    '<a href="' + src + '" clstag="' + clstag + '" target="_blank">' +
                    '<img src="' + url + '">' +
                    '</a>' +
                    '</div>');
            }

            //玩具乐器等类似楼层tab切换
            $('.floor').delegate('.tabs .tab', 'click', function () {
                var self = $(this);
                var index = self.index();
                if (self.siblings('.tab').length > 0) {
                    self.siblings('.tab').removeClass('curr');
                }
                self.addClass('curr');
                self.parents('.tabs').children('.tab-contents').addClass('hide');
                self.parents('.tabs').children('.tab-contents:eq(' + index + ')').removeClass('hide');
            });

            //品牌商标翻转效果
            $('.floor').delegate('.brand', 'mouseover', function () {
                var self = $(this);
                self.find('img').addClass('hide');
                self.find('.name').removeClass('hide');
            }).delegate('.brand', 'mouseleave', function () {
                var self = $(this);
                self.find('img').removeClass('hide');
                self.find('.name').addClass('hide');
            });

            //顶部广告关闭按钮
            $("#topbanner-close").bind("click", function () {
                $(".top-banner").remove();
            });

            //轮播图旁的切换
            $(".slideRight .control a").on("mouseover", function () {
                $(this).addClass("curr").siblings().removeClass("curr");

                var idx = $(this).index();

                var moveX = -242 * idx;
                $(this).parents(".sr-service").find("ul").animate({
                    "marginLeft": moveX
                }, 300);
            });

            //特卖
            // $(".temai").delegate(".tab li", "click", function () {
            //     $(this).addClass("curr").siblings().removeClass("curr");
            //
            //     var idx = $(this).index();
            //     $(this).parents(".tabs").find(".tab-cnt").eq(idx).removeClass("hide").siblings().addClass("hide");
            // });

            //全球直采
            $(".zhicai").delegate(".tab li", "click", function () {
                $(this).addClass("curr").siblings().removeClass("curr");

                var idx = $(this).index();
                $(this).parents(".tabs").find(".tab-cnt").eq(idx).removeClass("hide").siblings().addClass("hide");
            });

            //全球名店
            var t = null;
            $(".mingdian").delegate(".saleSwitch .ct", "mouseenter", function () {
                var _this = this;

                if (t != null) {
                    clearTimeout(t);
                }
                var idx = $(_this).index();
                $(_this).addClass("curr").siblings().removeClass("curr");

                t = setTimeout(function () {
                    $(_this).parents(".saleSwitch").find(".sales a").eq(idx).removeClass("hide").siblings().addClass("hide");
                }, 200);
            });
        },
        addSaleFloorEvent: function () {
            /*特卖楼层交互*/
            var specialsSaleInput = $("#specialsSaleJson");
            if (specialsSaleInput.length <= 0) {
                return false;
            }

            var specialsSaleJson = $.parseJSON(specialsSaleInput.val());

            var cacheCurTime = specialsSaleJson.currentTime;
            var cacheRange = 5 * 60 * 1000; //5分钟的服务器缓存时间,毫秒
            var maxCacheTime = cacheCurTime + cacheRange;

            var roundArray = specialsSaleJson.round;

            var bgTime = null,
                idx = 0;
            for (var i = 0; i < roundArray.length; i++) {
                idx = i;
                var beginTime = roundArray[i].beginTime;
                var endTime = roundArray[i].endTime;

                if (cacheCurTime >= beginTime) {
                    //缓存时间大于开始时间，说明缓存不会影响活动开始，直接跳过
                } else if (maxCacheTime >= beginTime) {
                    //缓存时间小于开始时间，则将缓存时间加5分钟和开始时间对比，若大于开始时间，则有可能活动已经开始，需要向服务器请求获取准确时间再对比
                    bgTime = beginTime;
                    break;
                }
            }

            timeModel.ajaxGetTime(null, function (data) {
                var serverTime = (new Date(data.timeNow)).getTime();

                // idx = $(".temai .tab li.curr").index();
                idx = 0; //only one tab
                endTime = roundArray[idx].endTime;
                pName = roundArray[idx].pName;

                if (bgTime != null && serverTime >= bgTime) {
                    //服务器时间大于开始时间，进行tab修正
                    reviseTab(idx, serverTime, pName);
                } else {
                    addItemCountdown(idx, serverTime);
                }
                doTicker(idx, endTime, serverTime);
                afterRevise(idx, serverTime);
            });

            function afterRevise(currIdx, serverTime) {
                //预告不显示进度
                initProcess(currIdx, serverTime);
                //请求价格、倒计时
                priceV2.init(".temai");
                lazyload.fn.init();
            }

            /**
             *
             * @param currIdx 修正后的序号
             * currIdx=1,选中第一个tab页
             * currIdx=2,选中第二个tab页，关闭第一个tab页
             * currIdx=3,选中第二个tab页，关闭第一个tab页
             * @param serverTime 当前时间
             * @param pName 已结束名称
             */
            function reviseTab(currIdx, serverTime, pName) {
                var liObj = $(".temai .tab li");
                var cntObj = $(".temai .tab-cnt");

                // liObj.eq(currIdx).find(".tit").text(pName);
                liObj.eq(currIdx).addClass("curr").siblings().removeClass("curr");
                cntObj.eq(currIdx).removeClass("hide").siblings().addClass("hide");
                cntObj.eq(currIdx).find("li").attr("status", "0");

                addItemCountdown(currIdx, serverTime);

                for (var i = currIdx - 1; i >= 0; i--) {
                    liObj.eq(i).attr("status", "0").addClass("finish");
                    cntObj.eq(i).find("li").attr("status", "0");
                }
            }

            function addItemCountdown(currIdx, serverTime) {
                var liList = $(".temai .tab li").eq(currIdx).siblings("li").not(".finish");
                if (serverTime < roundArray[currIdx].beginTime) {
                    liList = $(".temai .tab li").not(".finish");
                }

                liList.each(function () {
                    var idx = $(this).index();
                    var beginTime = roundArray[idx].beginTime;
                    var duringSecond = (beginTime - serverTime) / 1000;
                    var secondcount = parseInt(duringSecond);

                    $(".temai .tab-cnt").eq(idx).find("li .salePrice").after('<span secondcount="' + secondcount + '" render_type="temai" class="countdown"></span>');
                });
            }

            function doTicker(currIdx, endTime, serverTime) {
                var duringSecond = (endTime - serverTime) / 1000;
                if (duringSecond > 0 && serverTime >= roundArray[currIdx].beginTime) {
                    var secondcount = parseInt(duringSecond);
                    $(".temai .tab li").eq(currIdx).find(".tit").after('<span class="split"></span><span class="timeTag">仅剩</span><span secondcount="' + secondcount + '"></span>');
                }

                ticker.init();
            }

            function initProcess(currIdx, serverTime) {
                /*if (serverTime < roundArray[currIdx].beginTime) {
                    return false;
                }*/

                var promoIds = "";
                $(".temai .tab-cnt").eq(currIdx).find("[promoid]").each(function () {
                    var promoId = $(this).attr("promoid");
                    promoIds = promoIds + promoId + ",";
                });
                promoIds = promoIds.substring(0, promoIds.length - 1);

                var args = {
                    "ids": promoIds
                };
                indexV2Model.ajaxGetProcess(args, function (data) {
                    for (var i = 0; i < data.length; i++) {
                        $(".temai").find("[promoid='" + data[i].id + "']").each(function () {
                            var total = data[i].n;
                            var left = data[i].nb;
                            var percent = parseInt((1 - left / total) * 100);

                            $(this).find(".process").remove();
                            $(this).find(".salePrice").after('<span class="process"><span class="txt">已售' + percent + '%</span><span class="pBar"><span class="p-top" style="width: ' + percent + '%;"></span><span class="p-btm"></span></span></span>');

                            if (percent == 100) {
                                $(this).addClass("soldout");
                                $(this).find(".tag").html("已抢光<i></i>");
                            }
                        });
                    }
                });
            }
        },
        loadGuessYouLike: function () {
            var self = this;
            /*
                1.先判断是否登录，如果登录的话拿到pin
                2.调用diviner接口获取右侧数据，同时调用我们封装的接口获取左侧数据。
                3.如果右侧数据没有，隐藏整个楼层，如果左侧数据没有，隐藏左侧
            */

            //检查是否登录
            CheckLogin.isLogin({}, function(login) {
                login = false;
                var pin = "";
                if(login === true) {
                    pin = self.getCookie("pin");
                }


                var args = {
                    "pin": pin,
                    "lim": 12,
                    "keyword": ""
                };

                //调用左侧数据接口
                indexV2Model.getBrowserHistory({}, function(data) {
                    if(data.isSuccess === true && data.history && data.history.length > 0) {
                        var leftSideGoods = data.history;
                        var tpl = require("../template/indexV2RecmdLeft");
                        var leftHtml = tplModel.render({data: leftSideGoods}, tpl);
                        $('.guessLike .content').prepend(leftHtml);
                        priceV2.init('.guessLike');
                        lazyload.fn.init();
                    }

                    //调用右侧数据接口
                    indexV2Model.ajaxRecommend(args, function(ret) {
                        if (ret.success === true && ret.data && ret.data.length) {
                            var tpl = require("../template/indexV2RecmdRight");
                            var rightHtml = tplModel.render({data: ret.data}, tpl);
                            $('.guessLike .content').append(rightHtml);
                            lazyload.fn.init();
                            priceV2.init('.guessLike');

                            if(!data.isSuccess || !data.history || data.history.length <= 0) {
                                //隐藏右侧的头
                                $('.guessLike .like .head').addClass('hide');
                                setRightItemLength();
                            }

                            self.initHerizonalScroll();
                        } else {
                            //右侧没有数据
                            $('.guessLike').addClass('hide');
                        }
                    });
                });


            });

        },
        getCookie: function (name) {
            var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
            if (arr = document.cookie.match(reg)) {
                return unescape(arr[2]);
            } else {
                return null;
            }
        }
    };

    function setRightItemLength() {
        $('.guessLike .like').css("width" , "1210px");
        $('.guessLike .like .control .scrollbar').css("width", "1090px");
    }

    module.exports = indexV2Module;
});



// WEBPACK FOOTER //
// ./src/js/module/indexV2Module.js